import Vue from 'vue'
import Router from 'vue-router'
import trainConfirmChild from './views/trainConfirm/router'
import officialChild from './views/official/router'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: 'recruit/tutor',
    },
    {
      //临时使用，fix见面有礼链接错误
      path: '//recruit/tutor',
      name: 'indexFix',
      redirect: 'recruit/tutor',
    },
    {
      path: '/uploadHbase',
      name: 'uploadHbase',
      component: () =>
        import(/* webpackChunkName: "UploadHbase" */ './views/UploadHbase.vue'),
    },
    {
      path: '/recruit/:product',
      name: 'recruit',
      component: () =>
        import(/* webpackChunkName: "recruit" */ './views/recruit.vue'),
    },
    {
      path: '/subsidy/collect',
      name: 'subsidy',
      component: () =>
        import(/* webpackChunkName: "subsidyCollect" */ './views/subsidy/collect.vue'),
    },
    {
      path: '/offer/confirm/:offerId',
      name: 'offerConfirm',
      component: () =>
        import(/* webpackChunkName: "offerConfirm" */ './views/offer/offerConfirm.vue'),
    },
    {
      path: '/backCheck',
      name: 'backCheck',
      component: () =>
        import(/* webpackChunkName: "backCheck" */ './views/backCheck/index.vue'),
    },
    {
      path: '/backCheck/guide',
      name: 'backCheckGuide',
      component: () =>
        import(/* webpackChunkName: "backCheckGuide" */ './views/backCheck/guide.vue'),
    },
    {
      path: '/backCheck/success',
      name: 'backCheckSuccess',
      component: () =>
        import(/* webpackChunkName: "backCheckSuccess" */ './views/backCheck/success.vue'),
    },
    {
      path: '/trainConfirm/',
      name: 'trainConfirm',
      redirect: 'trainConfirm/main',
      component: () =>
        import(/* webpackChunkName: "trainConfirm" */ './components/WebMobialLayout.vue'),
      children: [...trainConfirmChild],
    },
    {
      path: '/official/',
      name: 'official',
      redirect: 'official/delivery/tutor',
      component: () =>
        import(/* webpackChunkName: "Official" */ './components/WebMobialLayout.vue'),
      children: [...officialChild],
    },
    // login路由需放到最下面，配合goLogin()中没有匹配的module
    {
      path: '/:module/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ './views/login.vue'),
      meta: {
        title: '用户验证',
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    const title = (to.meta && to.meta.title) || '猿辅导'
    document.title = title
  }
  if (to.hash) {
    const historyPath = to.hash.split('#')[1]
    next({
      path: historyPath,
      hash: '',
    })
  } else {
    next()
  }
})

export default router
